export default class Currency {
  public code: String;

  constructor(code: String) {
    this.code = code;
  }
}
